class DiscloseController{
    constructor($window, constants) {
        this.$window = $window;
        this.proceduresLink = constants.Links.Procedures;
        this.appendix1Link = constants.Links.Appendix1;
    }
}

DiscloseController.$inject = ['$window', 'constants'];

export default DiscloseController;


// WEBPACK FOOTER //
// ./app/disclose/disclose.controller.js